/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCalculationitemsGroup } from '../models/work-calculationitems-group';
import { WorkCreateCalculationitemsGroupDto } from '../models/work-create-calculationitems-group-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkUpdateCalculationitemsGroupDto } from '../models/work-update-calculationitems-group-dto';
import { WorkUpdateCalculationitemsGroupSortableRankDto } from '../models/work-update-calculationitems-group-sortable-rank-dto';

@Injectable({ providedIn: 'root' })
export class WorkCalculationitemsGroupsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `calculationitemsGroupsV2ControllerFindAllByCalculationId()` */
  static readonly CalculationitemsGroupsV2ControllerFindAllByCalculationIdPath = '/v2/calculationitems-groups/findAllByCalculationId/{id}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsGroupsV2ControllerFindAllByCalculationId()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsGroupsV2ControllerFindAllByCalculationId$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkCalculationitemsGroup>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsGroupsV2Service.CalculationitemsGroupsV2ControllerFindAllByCalculationIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkCalculationitemsGroup>>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsGroupsV2ControllerFindAllByCalculationId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsGroupsV2ControllerFindAllByCalculationId(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkCalculationitemsGroup>> {
    return this.calculationitemsGroupsV2ControllerFindAllByCalculationId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkCalculationitemsGroup>>): Array<WorkCalculationitemsGroup> => r.body)
    );
  }

  /** Path part for operation `calculationitemsGroupsV2ControllerFindAllCalculationitemsGroupsByCalculationIdPaginated()` */
  static readonly CalculationitemsGroupsV2ControllerFindAllCalculationitemsGroupsByCalculationIdPaginatedPath = '/v2/calculationitems-groups/byCalculationId/{id}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsGroupsV2ControllerFindAllCalculationitemsGroupsByCalculationIdPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsGroupsV2ControllerFindAllCalculationitemsGroupsByCalculationIdPaginated$Response(
    params: {
      id: number;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 1000
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by calculationId query param.
     *           <p>
     *              <b>Format: </b> filter.calculationId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.calculationId=$not:$like:John Doe&filter.calculationId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.calculationId'?: Array<string>;

    /**
     * Filter by calculationitems.optional query param.
     *           <p>
     *              <b>Format: </b> filter.calculationitems.optional={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.calculationitems.optional=$not:$like:John Doe&filter.calculationitems.optional=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.calculationitems.optional'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> sortableRank:ASC,calculationitems.sortableRank:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>sortableRank</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'sortableRank:ASC' | 'sortableRank:DESC'>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkCalculationitemsGroup>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'calculationId'?: (string | Array<string>);
'calculationitems.optional'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsGroupsV2Service.CalculationitemsGroupsV2ControllerFindAllCalculationitemsGroupsByCalculationIdPaginatedPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.calculationId', params['filter.calculationId'], {});
      rb.query('filter.calculationitems.optional', params['filter.calculationitems.optional'], {});
      rb.query('sortBy', params.sortBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkCalculationitemsGroup>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'calculationId'?: (string | Array<string>);
        'calculationitems.optional'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsGroupsV2ControllerFindAllCalculationitemsGroupsByCalculationIdPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsGroupsV2ControllerFindAllCalculationitemsGroupsByCalculationIdPaginated(
    params: {
      id: number;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 1000
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by calculationId query param.
     *           <p>
     *              <b>Format: </b> filter.calculationId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.calculationId=$not:$like:John Doe&filter.calculationId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.calculationId'?: Array<string>;

    /**
     * Filter by calculationitems.optional query param.
     *           <p>
     *              <b>Format: </b> filter.calculationitems.optional={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.calculationitems.optional=$not:$like:John Doe&filter.calculationitems.optional=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.calculationitems.optional'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> sortableRank:ASC,calculationitems.sortableRank:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>sortableRank</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'sortableRank:ASC' | 'sortableRank:DESC'>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkCalculationitemsGroup>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'calculationId'?: (string | Array<string>);
'calculationitems.optional'?: (string | Array<string>);
};
};
}> {
    return this.calculationitemsGroupsV2ControllerFindAllCalculationitemsGroupsByCalculationIdPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkCalculationitemsGroup>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'calculationId'?: (string | Array<string>);
'calculationitems.optional'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkCalculationitemsGroup>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'calculationId'?: (string | Array<string>);
'calculationitems.optional'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `calculationitemsGroupsV2ControllerUpdateSortableRanks()` */
  static readonly CalculationitemsGroupsV2ControllerUpdateSortableRanksPath = '/v2/calculationitems-groups/sortableRanks';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsGroupsV2ControllerUpdateSortableRanks()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsGroupsV2ControllerUpdateSortableRanks$Response(
    params: {
      body: Array<WorkUpdateCalculationitemsGroupSortableRankDto>
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsGroupsV2Service.CalculationitemsGroupsV2ControllerUpdateSortableRanksPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsGroupsV2ControllerUpdateSortableRanks$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsGroupsV2ControllerUpdateSortableRanks(
    params: {
      body: Array<WorkUpdateCalculationitemsGroupSortableRankDto>
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.calculationitemsGroupsV2ControllerUpdateSortableRanks$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `calculationitemsGroupsV2ControllerCreate()` */
  static readonly CalculationitemsGroupsV2ControllerCreatePath = '/v2/calculationitems-groups';

  /**
   * Required permissions: projects:create, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsGroupsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsGroupsV2ControllerCreate$Response(
    params: {
      body: WorkCreateCalculationitemsGroupDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationitemsGroup>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsGroupsV2Service.CalculationitemsGroupsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationitemsGroup>;
      })
    );
  }

  /**
   * Required permissions: projects:create, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsGroupsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsGroupsV2ControllerCreate(
    params: {
      body: WorkCreateCalculationitemsGroupDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationitemsGroup> {
    return this.calculationitemsGroupsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationitemsGroup>): WorkCalculationitemsGroup => r.body)
    );
  }

  /** Path part for operation `calculationitemsGroupsV2ControllerDelete()` */
  static readonly CalculationitemsGroupsV2ControllerDeletePath = '/v2/calculationitems-groups/{id}';

  /**
   * Required permissions: projects:delete, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsGroupsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsGroupsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsGroupsV2Service.CalculationitemsGroupsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: projects:delete, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsGroupsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsGroupsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.calculationitemsGroupsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `calculationitemsGroupsV2ControllerUpdate()` */
  static readonly CalculationitemsGroupsV2ControllerUpdatePath = '/v2/calculationitems-groups/{id}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsGroupsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsGroupsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateCalculationitemsGroupDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationitemsGroup>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsGroupsV2Service.CalculationitemsGroupsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationitemsGroup>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsGroupsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsGroupsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateCalculationitemsGroupDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationitemsGroup> {
    return this.calculationitemsGroupsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationitemsGroup>): WorkCalculationitemsGroup => r.body)
    );
  }

}
